<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title">Agenda</span>
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable mdl-textfield--floating-label mdl-textfield--align-right">
          <label class="mdl-button mdl-js-button mdl-button--icon" for="fixed-header-drawer-exp">
            <i class="material-icons">search</i>
          </label>
          <div class="mdl-textfield__expandable-holder">
            <input class="mdl-textfield__input" type="text" v-model="search" id="fixed-header-drawer-exp" v-on:input="searchVisits" debounce="30">
          </div>
        </div>
      </div>
    </header>    
    <SideMenu></SideMenu>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div v-if="error">
          {{error}}
        </div>
        <div v-for="visit in visits" class="calendar-card" :key="visit.id" v-on:click="openVisit(visit)" v-bind:class="visitClass(visit)">
          <i class="pull-right material-icons" v-html="visitIcon(visit)"></i>
          <div class="calendar-box">
            <div class="calendar-day">{{formatDay(visit.date)}}</div>
            <div class="calendar-day-of-week">{{formatDayOfWeek(visit.date)}}</div>
          </div>
          <strong>{{ visit.description }}</strong><br>
          {{ visit.visit_type_name }}<span v-if="visit.service_type"> / {{ visit.service_type.name }} </span><br>
          <div class="time-info" v-if="visit.start_date">
          <span v-if="visit.start_date"><i class="material-icons">timer</i> {{ formatHour(visit.start_date) }}</span>
          <span v-if="visit.end_date"> <i class="material-icons">timer_off</i> {{ formatHour(visit.end_date) }}</span>
          </div>
        </div>
        <button id="btn-add" class="mdl-button mdl-js-button mdl-button--fab mdl-button--colored" v-on:click="openVisit(null)" v-if="demo">
          <i class="material-icons">add</i>
        </button>        
      </div>
    </main>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import localDb from './localDb'
  import * as moment from 'moment'
  import SideMenu from './SideMenu.vue'

  var instancePath = 'instances/' + process.env.FSM_ENV
  var currentUser = localStorage.getItem('currentUser')
  var operatorRef = db.doc(instancePath + '/people/' + currentUser)
  var requestsRef = db.collection(instancePath + '/requests')
  var lastFill = null

  export default {
    components: {
      SideMenu
    },
    data: function() {
      return {
        currentName: localStorage.getItem('currentName'),
        demo: process.env.FSM_DEMO,
        today: this.$route.params.d || moment().format('YYYY-MM-DD'),
        search: '',
        visits: [],
        instancePath: instancePath,
        error: null,
        refresh: true
      }  
    },
    mounted() {
      let data = this
      if (localStorage.getItem('currentUser') == null || localStorage.getItem('accepted_eula') != 'yes') {
        this.$router.push("/")
      }
      this.initListener()
    },
    methods: {
      initListener: function() {
        var currentUser = localStorage.getItem('currentUser')
        let data = this
        let operatorRef = db.doc('instances/' + process.env.FSM_ENV + '/people/' + currentUser)
        operatorRef.collection('visits').onSnapshot(snapshot => {
          console.log("listening")
          snapshot.docChanges().forEach(function(change) {
            console.log(change.doc.id)
            if (change.type == 'removed') {
              data.deleteVisit(change.doc.id)
            } else {
              data.saveVisit(change.doc.data(), change.doc.id);
            }
            data.refresh = true
          })
        }, err => {
          console.log(err)
          data.error = err
        })
        setTimeout(() => {
          this.fillDay()
        }, 1000)
      },
      fillDay: function() {

        if (this.refresh) {

          console.log("fillDay")

          let now = new Date().getMilliseconds()

          //if (lastFill != null && now - lastFill < 500)
          //  return

          lastFill = now

          let data = this

          data.visits.splice(0, data.visits.length)

          var calendar_days_before = 7
          var calendar_days_after = 14

          if (data.$i18n != null) {
            calendar_days_before = parseInt(data.$i18n.t('calendar.display_days_before'));
            calendar_days_after = parseInt(data.$i18n.t('calendar.display_days_after'));
          }

          let first_date = moment().subtract(calendar_days_before, 'days').format('YYYY-MM-DD')
          let last_date = moment().add(calendar_days_after, 'days').format('YYYY-MM-DD')

          let temp_visits = []
          localDb.visits.orderBy('date').each(visit => {
            if (visit.date > first_date)
              temp_visits.push(visit)
          })

          temp_visits = temp_visits.sort (function(a, b) {
            var date_a = a.start_date
            if (date_a == null)
              date_a = a.date
            var date_b = b.start_date
            if (date_b == null)
              date_b == b.date
            return a.date.localeCompare(b.date)
          })

          this.refresh = false

          this.visits = temp_visits

        }

        setTimeout(() => {
          this.fillDay()
        }, 10000)

      },
      saveVisit: function(doc, id) {
        doc.id = id
        localDb.visits.where({id: id}).first().then(function(visit) {
          if (visit.version < doc.version) {
            localDb.visits.put(doc)
          } else {
            console.log("blocked... good!")
          }
        }).catch(function() {
          localDb.visits.put(doc)
        })
      },
      deleteVisit: function(id) {
        localDb.visits.delete(id)
      },      
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },
      formatDay: function(date) {
        return moment(date).format('DD/MM')
      },
      formatDayOfWeek: function(date) {
        return moment(date).format('ddd')
      },
      formatHour: function(date) {
        return moment(date).format('DD/MM HH:mm')
      },
      nextDay: function() {
        this.today = moment(this.today).add(1, 'd').format('YYYY-MM-DD');
        this.fillDay()
      },
      previousDay: function() {
        this.today = moment(this.today).subtract(1, 'd').format('YYYY-MM-DD');
        this.fillDay()
      },      
      send: function(id) {
        var task = this.tasks[id]
        if (task.status == 'open') {
          task.status = 'started';
          operatorRef.collection('visits').doc(id).update({
            status: 'started'
          })
        } else if (task.status == 'started') {
          current_id = id
          current_task = task
          this.$router.push("/visits/" + id)
        }
      },
      openVisit: function(visit) {
        if (visit == null)
          this.$router.push("/visits/new")
        else
          this.$router.push("/visits/" + visit.id)
      },
      visitUrl: function(visit) {
        return '/visits/' + visit.id
      },
      visitActions: function(visit) {
        //if (task.status == 'open')
          //return ['play_arrow'];
        //if (task.status == 'started')
          //return ['stop'];
        return null;
      },
      visitIcon: function(visit) {
        if (visit.status == 'closed') {
          if (visit.received_date)
            return 'done_all'
          else
            return 'done'  
        }
        return null;
      },
      visitClass: function(visit) {
        if (visit.status == 'open')
          return 'open';
        if (visit.status == 'started')
          return 'started';
        if (visit.status == 'closed')
          return 'completed';
        return 'empty';
      },
      searchVisits: function() {
        if (!/^\s*$/.test(this.search)) {
          if (this.search.length >= 2) {
            let data = this
            data.visits.splice(0, data.visits.length)
            localDb.visits.each(visit => {
              if (visit.real_state_name.search(new RegExp(this.search, 'i')) != -1 || visit.real_state_address.search(new RegExp(this.search, 'i')) != -1) {
                data.visits.splice(0, 0, visit)
              }
            })            
          }
        } else {
          this.fillDay()
        }

      }
    }
  }
</script>
<style>
  .calendar-box {
    text-align: center;
    height: 40px;
    float: left;
    margin-right: 12px;
  }
  .calendar-day {
    font-size: 18px;
  }
  .calendar-day-of-week {
    font-size: 12;
  }
  .calendar-card {
    margin-top: 1px;
  }
  .calendar-card:before,
  .calendar-card:after {
    content: " ";
    display: table;
  }
  .calendar-card:after {
    clear: both;
  }
  .calendar-card {
    padding: 10px;
  }
  .welcome-card {
    margin-top: 19px;
  }
  .open {
    color: #000;
    background-color: #fff;
  }
  .started {
    color: black;
    background-color: #dcf8c6;
  }
  .completed {
    color: white;
    background-color: green;
  }
  .empty {
    color: black;
    background-color: #e0e0e0;
  }
  h5 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  #btn-add {
    position: fixed;
    right: 50px;
    bottom: 50px;
  }
  .time-info {
    margin-left: 58px;
    font-size: 14px;
  }
  .time-info .material-icons {
    margin-top: 4px;
    font-size: 14px !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/CalendarView.vue